module.exports = "\np a[routerLink] { font-size:2rem; }\n#desc { background-color:yellow; padding:20px;  }\n*:focus {\n    -webkit-box-shadow: 0 0 0 1px white, 0 0 0 3px black, 0 0 0 4px white;\n            box-shadow: 0 0 0 1px white, 0 0 0 3px black, 0 0 0 4px white;\n    z-index: 1;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main